<template>
  <div class="mxr-product-item">
    <figure class="mxr-product-item__figure">
      <div class="mxr-product-item__img">
        <img v-if="selectedColor && product.productInfo.productId === selectedColor[1]" :src="`${selectedColor[0].openGraph.image}`" alt="">
        <img v-else :src="`${product.openGraph.image}`" alt="">
      </div>
    </figure>
  </div>
</template>

<script>
  export default {
    name: 'product-pic',
    props: ['product'],
    data() {
      return {
      };
    },
    computed: {
      selectedColor() {
        return this.$store.state.selectedColor;
      },
    },
  };
</script>

<style lang="scss" scoped>
  .mxr-product-item {
    display: flex;
    flex-direction: column;
    flex: 1;
    justify-content: space-between;
    &__figure {
      width: 100%;
      margin: auto;
      text-align: right;
    }
    &__img {
      img {
        margin: auto;
        display: block;
        -webkit-user-drag: none;
        max-width: 64%;
        @include breakpoint(medium) {
          max-width: 40%;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// ProductPic.vue?4dac1972